module.exports = __webpack_public_path__ + "static/principles-2e150cc5d7abad54c7c86dfbd8b2ef5b.png";